
var authServiceObj =
{
  login(credentials) {
        return new Promise((resolve, reject) => {
            axios.post("/api/auth/login", credentials, { errorHandle: false })
        .then(function (result) {
          console.log("AuthService login - resolve")
          resolve(result.data.auth_token);
        })
        .catch(function (errors) {
          console.log("AuthService login - reject")

          var errMsg = '';
          errMsg += errors.response.data.Message;//concatenate array to string

          reject(errMsg);
        });
    });
  }
}

export const authService = authServiceObj;
